/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../../orders/orders.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import formatDate from "../../../../helper/dateFormatter";

const OrderReportTable = (props) => {
  const t = props.t;
  return (
    <div className={classes.root}>
      <TableContainer>
        {/* <Table className={classes.table} aria-label="simple table"> */}
        <Table
          className={classes.table + " " + "newGlobalTable"}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("customerName");
                  }}
                >
                  <b>{t("CUSTOMER_NAME")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "customerName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell>
                <b>{t("Owner")}</b>
              </TableCell>
              <TableCell>
                <b>{t("STATUS")}</b>
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("amount");
                  }}
                >
                  {/* Sort indication */}
                  <b>{t("AMOUNT")}</b>
                  {props.sortBy === "amount" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                align="right"
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderDate");
                }}
              >
                {/* Sort indication */}
                {props.sortBy === "orderDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
                <b>{t("ORDER_DATE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.orders.map((row) => (
              <TableRow
                key={row.orderId}
                // hover
              >
                <TableCell component="th" scope="row">
                  {row.orderId}
                </TableCell>
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                  <TableCell>
                    {row.accountName} {row.ban && ` (${row.ban})`}
                  </TableCell>
                )}
                <TableCell>{row.clientName}</TableCell>
                <TableCell>{row.orderStatus}</TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{currencyFormatter(row.amount)}</TableCell>
                )}
                <TableCell align="right">
                  {formatDate(row.orderDate)}
                </TableCell>
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.orders.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("NO_ORDER_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalOrderCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(props.totalOrderCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(props.totalOrderCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(OrderReportTable);
